/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  AddExternalMCPForm,
  AddExternalMCPForm$Outbound,
  AddExternalMCPForm$outboundSchema,
} from "./addexternalmcpform.js";
import {
  AddFunctionsForm,
  AddFunctionsForm$Outbound,
  AddFunctionsForm$outboundSchema,
} from "./addfunctionsform.js";
import {
  AddOpenAPIv3DeploymentAssetForm,
  AddOpenAPIv3DeploymentAssetForm$Outbound,
  AddOpenAPIv3DeploymentAssetForm$outboundSchema,
} from "./addopenapiv3deploymentassetform.js";
import {
  AddPackageForm,
  AddPackageForm$Outbound,
  AddPackageForm$outboundSchema,
} from "./addpackageform.js";

export type EvolveForm = {
  /**
   * The ID of the deployment to evolve. If omitted, the latest deployment will be used.
   */
  deploymentId?: string | undefined;
  /**
   * The external MCP servers, identified by slug, to exclude from the new deployment when cloning a previous deployment.
   */
  excludeExternalMcps?: Array<string> | undefined;
  /**
   * The functions, identified by slug, to exclude from the new deployment when cloning a previous deployment.
   */
  excludeFunctions?: Array<string> | undefined;
  /**
   * The OpenAPI 3.x documents, identified by slug, to exclude from the new deployment when cloning a previous deployment.
   */
  excludeOpenapiv3Assets?: Array<string> | undefined;
  /**
   * The packages to exclude from the new deployment when cloning a previous deployment.
   */
  excludePackages?: Array<string> | undefined;
  /**
   * If true, the deployment will be created in non-blocking mode where the request will return immediately and the deployment will proceed asynchronously.
   */
  nonBlocking?: boolean | undefined;
  /**
   * The external MCP servers to upsert in the new deployment.
   */
  upsertExternalMcps?: Array<AddExternalMCPForm> | undefined;
  /**
   * The tool functions to upsert in the new deployment.
   */
  upsertFunctions?: Array<AddFunctionsForm> | undefined;
  /**
   * The OpenAPI 3.x documents to upsert in the new deployment.
   */
  upsertOpenapiv3Assets?: Array<AddOpenAPIv3DeploymentAssetForm> | undefined;
  /**
   * The packages to upsert in the new deployment.
   */
  upsertPackages?: Array<AddPackageForm> | undefined;
};

/** @internal */
export type EvolveForm$Outbound = {
  deployment_id?: string | undefined;
  exclude_external_mcps?: Array<string> | undefined;
  exclude_functions?: Array<string> | undefined;
  exclude_openapiv3_assets?: Array<string> | undefined;
  exclude_packages?: Array<string> | undefined;
  non_blocking?: boolean | undefined;
  upsert_external_mcps?: Array<AddExternalMCPForm$Outbound> | undefined;
  upsert_functions?: Array<AddFunctionsForm$Outbound> | undefined;
  upsert_openapiv3_assets?:
    | Array<AddOpenAPIv3DeploymentAssetForm$Outbound>
    | undefined;
  upsert_packages?: Array<AddPackageForm$Outbound> | undefined;
};

/** @internal */
export const EvolveForm$outboundSchema: z.ZodMiniType<
  EvolveForm$Outbound,
  EvolveForm
> = z.pipe(
  z.object({
    deploymentId: z.optional(z.string()),
    excludeExternalMcps: z.optional(z.array(z.string())),
    excludeFunctions: z.optional(z.array(z.string())),
    excludeOpenapiv3Assets: z.optional(z.array(z.string())),
    excludePackages: z.optional(z.array(z.string())),
    nonBlocking: z.optional(z.boolean()),
    upsertExternalMcps: z.optional(z.array(AddExternalMCPForm$outboundSchema)),
    upsertFunctions: z.optional(z.array(AddFunctionsForm$outboundSchema)),
    upsertOpenapiv3Assets: z.optional(
      z.array(AddOpenAPIv3DeploymentAssetForm$outboundSchema),
    ),
    upsertPackages: z.optional(z.array(AddPackageForm$outboundSchema)),
  }),
  z.transform((v) => {
    return remap$(v, {
      deploymentId: "deployment_id",
      excludeExternalMcps: "exclude_external_mcps",
      excludeFunctions: "exclude_functions",
      excludeOpenapiv3Assets: "exclude_openapiv3_assets",
      excludePackages: "exclude_packages",
      nonBlocking: "non_blocking",
      upsertExternalMcps: "upsert_external_mcps",
      upsertFunctions: "upsert_functions",
      upsertOpenapiv3Assets: "upsert_openapiv3_assets",
      upsertPackages: "upsert_packages",
    });
  }),
);

export function evolveFormToJSON(evolveForm: EvolveForm): string {
  return JSON.stringify(EvolveForm$outboundSchema.parse(evolveForm));
}
